import React from "react";
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

export default function OnlineTrainingPage() {
  return (
    <div style={{ backgroundColor: "#f9f9f9" }}>
      {/* Hero Section */}
      <section
        className="text-center text-white py-5 my-5"
        style={{
          background:
            "linear-gradient(120deg, #001f3f, #003c8f, #0056b3)",
          color: "#fff",
        }}
      >
        <Container>
          <h1 className="display-5 fw-bold mb-3">
            Transforming Education Through <span className="text-warning">Real-Time Learning</span>
          </h1>
          <p className="lead mb-4">
            Olewin Academy — India’s <strong>#1 Research & Training Academy</strong><br />
            offering live online classes, hybrid learning, and <strong>paid internships</strong> across all programs.
          </p>
          <Button variant="warning" size="lg" href="/enroll" className="fw-bold me-3">
            Enroll Now
          </Button>
          <Button variant="light" size="lg" href="/contact" className="fw-bold">
            Contact Us
          </Button>
        </Container>
      </section>

      {/* About Online Training */}
      <section className="py-5">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <Image
                src="https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/assets/images/online_learning.jpg"
                fluid
                rounded
                className="shadow"
              />
            </Col>
            <Col md={6}>
              <h2 className="fw-bold text-primary mb-3">How Our Online & Hybrid Training Works</h2>
              <p className="text-muted">
                Our online training programs are structured for maximum engagement — delivering
                <strong> 2-hour daily live sessions</strong> by top mentors, followed by guided project work
                and personalized mentorship.
              </p>
              <ul className="text-muted">
                <li>🎓 Live + Recorded sessions with expert trainers</li>
                <li>🧠 Daily 2-hour sessions, real-time interaction</li>
                <li>💻 Hands-on projects and case studies</li>
                <li>🏆 Paid internships after course completion</li>
                <li>🌍 Hybrid mode (Online + On-campus)</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Academic Programs */}
      <section className="py-5 bg-light">
        <Container>
          <h2 className="text-center fw-bold mb-5 text-primary">
            Explore Our Major Training Programs
          </h2>
          <Row className="g-4">
            {[
              {
                title: "IIT-JEE Coaching",
                desc: "Expert faculty guiding students through JEE Mains & Advanced with conceptual clarity and test series.",
              },
              {
                title: "NEET Preparation",
                desc: "Comprehensive NEET coaching with in-depth Biology, Physics, and Chemistry modules and mock exams.",
              },
              {
                title: "GATE & IIT-JAM",
                desc: "Advanced coaching for Engineering & Science graduates preparing for GATE and JAM entrances.",
              },
              {
                title: "CA, CPT & CS",
                desc: "Structured Chartered Accountancy, CPT and Company Secretary training with real-world finance exposure.",
              },
              {
                title: "LAW Entrance Training",
                desc: "Full CLAT, AILET, LSAT training with legal aptitude, reasoning, and case-study approach.",
              },
              {
                title: "Abroad Studies & IELTS",
                desc: "Study Abroad programs including IELTS, TOEFL, GRE, GMAT with global university guidance.",
              },
              {
                title: "AI, ML & Data Science",
                desc: "Industry-driven practical courses in Artificial Intelligence, Machine Learning, and Big Data Analytics.",
              },
              {
                title: "Quantum & Space Tech",
                desc: "Cutting-edge Quantum Computing, Space Technology, and Robotics research-oriented training.",
              },
              {
                title: "Energy, GeoScience & Renewable Systems",
                desc: "Hybrid programs integrating Energy Sector, Geo-Informatics, and Sustainable Engineering.",
              },
              {
                title: "Professional & Research Internships",
                desc: "Work on live projects, publish papers, and gain stipends during internships in your chosen field.",
              },
            ].map((prog, i) => (
              <Col md={6} lg={4} key={i}>
                <Card className="h-100 shadow-sm border-0">
                  <Card.Body>
                    <Card.Title className="fw-bold text-primary">{prog.title}</Card.Title>
                    <Card.Text className="text-muted">{prog.desc}</Card.Text>
                    <Button variant="outline-primary" href="#enroll" className="fw-bold">
                      Enroll
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Real-Time Learning Section */}
      <section className="py-5">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <h2 className="fw-bold text-primary mb-3">
                Real-Time Interactive Learning Experience
              </h2>
              <p className="text-muted">
                Each session at Olewin Academy is designed to simulate real-world problem solving.
                Learners collaborate in live virtual classrooms, access high-quality materials, and
                receive individual feedback from expert mentors.
              </p>
              <ul className="text-muted">
                <li>🕑 2 hours of interactive sessions daily</li>
                <li>👨‍🏫 Live Q&A, group discussions, and coding sessions</li>
                <li>📚 Recorded lectures for self-paced revision</li>
                <li>🤝 One-on-one mentoring & progress tracking</li>
                <li>💼 Career support with paid internship offers</li>
              </ul>
              <Button variant="primary" href="#enroll" className="fw-bold mt-2">
                Get Started
              </Button>
            </Col>
            <Col md={6} className="text-center">
              <Image
                src="https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/assets/images/live_class.png"
                fluid
                rounded
                className="shadow-sm"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Enroll Section */}
      <section
        id="enroll"
        className="py-5 text-white text-center"
        style={{
          background: "linear-gradient(120deg, #002d72, #0056b3)",
        }}
      >
        <Container>
          <h2 className="fw-bold mb-3">Join Olewin Academy’s Online Training Today</h2>
          <p className="lead mb-4">
            Experience world-class teaching, live sessions, research guidance, and paid internships
            — all in one platform.
          </p>
          <Button
            href="https://olewinacademy.in/enroll"
            variant="warning"
            size="lg"
            className="fw-bold me-3"
          >
            Enroll Now
          </Button>
          <Button href="#contact" variant="light" size="lg" className="fw-bold">
            Contact Support
          </Button>
        </Container>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-5 bg-light">
        <Container>
          <Row>
            <Col md={6}>
              <h3 className="fw-bold text-primary mb-3">Contact Us</h3>
              <p className="text-muted">
                For admissions, collaborations, or partnership inquiries, reach out to our academic
                and support teams.
              </p>
              <p className="fw-bold">📞 +91-9876543210</p>
              <p className="fw-bold">✉️ info@olewinacademy.in</p>
              <p className="fw-bold">🌐 www.olewinacademy.in</p>
            </Col>
            <Col md={6}>
              <Card className="shadow-sm border-0">
                <Card.Body>
                  <h5 className="fw-bold text-primary mb-3">Quick Enquiry</h5>
                  <form>
                    <input
                      type="text"
                      placeholder="Full Name"
                      className="form-control mb-2"
                      required
                    />
                    <input
                      type="email"
                      placeholder="Email Address"
                      className="form-control mb-2"
                      required
                    />
                    <input
                      type="text"
                      placeholder="Program Interested In"
                      className="form-control mb-2"
                    />
                    <textarea
                      placeholder="Message"
                      className="form-control mb-3"
                      rows="3"
                    ></textarea>
                    <Button variant="primary" className="w-100 fw-bold">
                      Submit
                    </Button>
                  </form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Footer */}
      <footer className="py-4 text-center text-white" style={{ background: "#001f3f" }}>
        <Container>
          <p className="mb-0">
            © {new Date().getFullYear()} Olewin Academy | Empowering Learners Globally with Research & Innovation
          </p>
        </Container>
      </footer>
    </div>
  );
}
